// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { cleaningProcedureId } from './CleaningProcedure';
import { equipmentTypeId } from './EquipmentType';
import { z } from 'zod';
export const cleaningProcedureEquipmentType = z.object({
    cleaning_procedure_id: cleaningProcedureId,
    equipment_type_id: equipmentTypeId,
});
export const cleaningProcedureEquipmentTypeInitializer = z.object({
    cleaning_procedure_id: cleaningProcedureId,
    equipment_type_id: equipmentTypeId,
});
export const cleaningProcedureEquipmentTypeMutator = z.object({
    cleaning_procedure_id: cleaningProcedureId.optional(),
    equipment_type_id: equipmentTypeId.optional(),
});
//# sourceMappingURL=CleaningProcedureEquipmentType.js.map